export default __webpack_public_path__ + "bcb2050a415f370d1f7d8c63fe01782d.png";